/* eslint-disable perfectionist/sort-named-exports */

import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  forwardRef,
} from "react";

import { TextField } from "@radix-ui/themes";

import { cn } from "../util.cn";

interface RootProps extends ComponentPropsWithoutRef<typeof TextField.Root> {}
type RootRef = ComponentRef<typeof TextField.Root>;
const Root = forwardRef<RootRef, RootProps>((props, ref) => {
  const { className, radius = "large", ...restProps } = props;
  return (
    <TextField.Root
      {...restProps}
      className={cn("hotfix--input-container", "w-full", className)}
      radius={radius}
      ref={ref}
    />
  );
});
Root.displayName = TextField.Root.displayName;

const { Slot } = TextField;
interface SlotProps extends ComponentPropsWithoutRef<typeof TextField.Slot> {}

export { Root, type RootProps, Slot, type SlotProps };
